import { TbSettings, TbLock, TbDatabase } from 'react-icons/tb'
import { Text } from 'ui-kit/typography'
import { LINKS } from 'routes/constants'
import { IntegrationCompactType } from 'routes/Integrations/helpers/types'
import NavLink from 'ui-kit/actions/link/NavLink'
import clsx from 'clsx'
import classes from './IntegrationsGrid.module.scss'

export * from './IntegrationsGridSkeleton'

export const IntegrationsGrid = ({
  integrations,
}: {
  integrations: IntegrationCompactType[]
}) => {
  const result: JSX.Element[] = []

  integrations?.forEach(
    ({ key, name, logoUri: iconSrc, onDemand, hasAuth, hasData }) => {
      const showTagsList = onDemand || hasAuth || hasData

      result.push(
        <li className={classes.item} key={key}>
          <div className={classes.content}>
            <div className={classes.icon}>
              <img
                width={50}
                height={50}
                loading='lazy'
                className={classes.icon_image}
                src={iconSrc}
                alt={name}
              />
            </div>
            <div className={classes.links}>
              <div className={classes.name}>
                <NavLink
                  className={classes.name_link}
                  href={`${LINKS.INTEGRATIONS}/${key}`}
                >
                  {name}
                </NavLink>
              </div>
            </div>
          </div>
          {showTagsList && (
            <ul className={classes.tags}>
              {onDemand && (
                <li className={clsx(classes.tag, classes.tag__bordered)}>
                  <TbSettings className={classes.tag_icon} />
                  <Text as={'span'} className={classes.tag_caption}>
                    on-demand
                  </Text>
                </li>
              )}
              {hasData && (
                <li className={clsx(classes.tag)}>
                  <TbDatabase className={classes.tag_icon} />
                  <Text as={'span'} className={classes.tag_caption}>
                    data
                  </Text>
                </li>
              )}
              {hasAuth && (
                <li className={clsx(classes.tag)}>
                  <TbLock className={classes.tag_icon} />
                  <Text as={'span'} className={classes.tag_caption}>
                    auth
                  </Text>
                </li>
              )}
            </ul>
          )}
        </li>,
      )
    },
  )

  return <ul className={classes.list}>{result}</ul>
}
